import { formatNumberWithCommas } from '@frontend/editor/utils';
import { GetBillingResponseType } from '@frontend/sorghum/interface';
import { TFunction } from 'i18next';

interface PlanDisplay {
  planTitle: string;
  price: string;
  period: string;
}

// 續扣緩衝期（plan=TRIAL 但訂閱實質存活）的共用顯示邏輯，三個 setting hook 共用。
// WHY: 緩衝期顯示「試用方案」會讓已付費客戶誤以為退訂成功（2026-08 客訴根因）
export function getTrialPlanDisplay(
  billing: GetBillingResponseType,
  t: TFunction,
  trialDisplay: PlanDisplay,
): PlanDisplay {
  if (billing.pendingAdvanced) {
    // 已付款待生效（續扣重試成功，期間錨在緩衝列結束）
    return {
      planTitle: t('setting.payment.advance'),
      price: `${
        billing.country === 'TW' ? 'NT$' : 'US$'
      } ${formatNumberWithCommas(billing.pendingAdvanced.amount ?? 0)}`,
      period: `/${
        billing.pendingAdvanced.period === 1
          ? t('setting.payment.month')
          : t('setting.payment.year')
      }`,
    };
  }
  if (billing.paymentRetrying) {
    return {
      planTitle: t('setting.payment.advanceRetrying'),
      price: '-',
      period: '',
    };
  }
  if (billing.paymentRetryStopped) {
    // 重試耗盡/永久失敗：不會再自動扣款，只能靠更新付款方式救回
    return {
      planTitle: t('setting.payment.advanceRetryStopped'),
      price: '-',
      period: '',
    };
  }
  return trialDisplay;
}
